 import styles from "./ProcessingModal.module.scss";
 import processing from "../../../assets/icons/processing.svg";
import { useTranslation } from "react-i18next";
interface ProcessingModalProps {
  setIsModalProcessingVisible: (arg: boolean) => void;
}

const ProcessingModal: React.FC<ProcessingModalProps> = ({
  setIsModalProcessingVisible,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        {/* <img
          src={close}
          alt="close"
          onClick={() => setIsModalProcessingVisible(false)}
        /> */}
      </div>
      <div className={styles.root_main}>
        <img src={processing} alt="processing" width={56} height={56} />
        <p className={styles.root_main_message}>{t("Processing request")}</p>
      </div>
      {/* <div className={styles.root_footer}>
        <Button
          onClick={() => setIsModalProcessingVisible(false)}
          text={t("Close")}
          type={"default"}
          classNames={styles.root_footer_button}
        />
      </div> */}
    </div>
  );
};

export default ProcessingModal;
